import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

const UtmParamsChecker = ({ isAuthed }) => {
    const location = useLocation();
    // const hsaFields = ['hsa_acc', 'hsa_cam', 'hsa_grp', 'hsa_ad', 'hsa_src', 'hsa_net', 'hsa_ver', 'fbclid'];
    const utmFields = ['utm_campaign', 'utm_source', 'utm_medium', 'utm_content', 'utm_term', 'hsa_acc', 'hsa_cam', 'hsa_grp', 'hsa_ad', 'hsa_src', 'hsa_net', 'hsa_ver', 'fbclid', 'irclickid'];

    const getUtmParamsFromLocalStorage = () => {
        const utmValues = Object.fromEntries(
            utmFields.map(field => [field, localStorage.getItem(field)]).filter(([_, value]) => value)
        );

        if (Object.values(utmValues).some(value => value !== null && value !== undefined)) {
            const utmUrlString = `?${new URLSearchParams(utmValues).toString()}`;

            // append UTM params to URL
            window.history.replaceState({}, '', `${location.pathname}${utmUrlString}`);
        }
    };

    const getUtmParamsFromUrl = () => {
        const params = new URLSearchParams(location.search);

        const utmValues = Object.fromEntries(
            utmFields.map(field => [field, params.get(field)]).filter(([_, value]) => value)
        );

        if (Object.keys(utmValues).length > 0) {
            Object.entries(utmValues).forEach(([key, value]) => {
                localStorage.setItem(key, value);
            });
        } else {
            // if no UTM parameters found in the URL, try retrieving from localStorage
            return getUtmParamsFromLocalStorage();
        }
    };

    const clearUtms = () => {
        // clear UTM params from URL
        window.history.replaceState({}, '', location.pathname);

        // clear UTM params from localStorage
        utmFields.forEach(field => localStorage.removeItem(field));
    };

    useEffect(() => {
        if (isAuthed) return clearUtms();

        getUtmParamsFromUrl();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    return null;
};

UtmParamsChecker.propTypes = {
    isAuthed: PropTypes.bool.isRequired
};

export default UtmParamsChecker;
